import { TextFieldSize } from '@bechtel/gds';
import { EditCountFieldStyled, EditCountTextFieldStyled } from './styled';

interface CountFieldProps {
  count: number;
}

export const CountField: React.FC<CountFieldProps> = ({
  count

}) => {
  return (
    <EditCountFieldStyled btnDisabled={true} itemCount={count} flexShrink={{ sm: '0' }}>

      <EditCountTextFieldStyled
        size={TextFieldSize.SMALL}
      >{count}</EditCountTextFieldStyled>

    </EditCountFieldStyled>
  );
};
